module.exports = __webpack_public_path__ + "img/W-C128.3de0e5a7.jpg";